/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

/**
 * Current lifecycle state of an organisation's building access.
 */
export type BuildingAccessControlOrganisationStatus =
    (typeof BuildingAccessControlOrganisationStatus)[keyof typeof BuildingAccessControlOrganisationStatus];

export const BuildingAccessControlOrganisationStatus = {
    Active: 1,
    Inactive: 2,
    Pending: 3,
    Expired: 4,
} as const;
